import * as React from 'react'
import { MemberMainConnected } from './MemberMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const MemberMainExamples = () => {
  return (
    <div className="MemberMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <MemberMainConnected />
      </Provider>
    </div>
  )
}
